import * as React from 'react';
import { Bem } from '../../utils/css.js';
import '../../constants.js';
import './NavigationProductName.scss.js';

const bem = Bem.create("vai-navigation-product-name");
const NavigationProductName = ({ text }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: bem.block()
  }, /* @__PURE__ */ React.createElement("div", {
    className: bem.element("content")()
  }, text));
};

export { NavigationProductName };
